import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { CheckCurrentStatus, Status } from "../types/types";

import { formatDate } from "../utils/utils";
import { Chip } from "@mui/material";

type CurrentStatusProps = {
  data: CheckCurrentStatus;
};
const CurrentStatus = (props: CurrentStatusProps) => {
  const { data } = props;
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Host</TableCell>
            <TableCell>Reporter Location</TableCell>
            <TableCell>Current Status</TableCell>
            <TableCell>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell component="th" scope="row">
              {data.host}
            </TableCell>
            <TableCell>{data.location}</TableCell>
            <TableCell>
              <CheckStatus status={data.status} />
            </TableCell>
            <TableCell>{formatDate(data.date)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

type StatusProps = {
  status: Status;
};
const CheckStatus = (props: StatusProps) => {
  const { status } = props;

  switch (status) {
    case Status.UP:
    case Status.CONFIRMED_UP:
    case Status.UNCONFIRMED_UP:
      return <Chip  sx={{ fontSize: 12, fontWeight: 'bold'}} label="UP" variant="filled" color="success" />;
    case Status.DOWN:
    case Status.CONFIRMED_DOWN:
    case Status.UNCONFIRMED_DOWN:
      return <Chip sx={{ fontSize: 12, fontWeight: 'bold' }} label="DOWN" variant="filled" color="warning" />;

    default:
      return <p>N/A</p>;
  }

};
export default CurrentStatus;
